import React from "react"
import Responsive from "react-responsive"
import SimpleSlider from "components/Product/SimpleSlider"

const ProductSlider = ( { products, Card } ) => <div className={"ProductSlider"}>
  <Responsive minWidth={1001}>
    <SimpleSlider slidesToShow={4} className={"SliderProducts"} dots={false}>
      {products.map( product => <Card key={product.map_id}
                                      product={product}/> )
      }
    </SimpleSlider>
  </Responsive>

  <Responsive maxWidth={1000} minWidth={920}>
    <SimpleSlider slidesToShow={3} className={"SliderProducts"} dots={false}>
      {products.map( product => <Card key={product.map_id}
                                      product={product}/> )
      }
    </SimpleSlider>
  </Responsive>
  <Responsive minWidth={351} maxWidth={920}>
    <SimpleSlider slidesToShow={2} dots={false} className={"SliderProducts"}>
      {products.map( product => <Card key={product.map_id}
                                      product={product}/> )
      }
    </SimpleSlider>
  </Responsive>

  <Responsive maxWidth={350}>
    <SimpleSlider slidesToShow={1} dots={false} className={"SliderProducts"}>
      {products.map( product => <Card key={product.map_id}
                                      product={product}/> )
      }
    </SimpleSlider>
  </Responsive>
</div>

export default ProductSlider


// WEBPACK FOOTER //
// ./src/components/Product/ProductSlider.js